<template>
  <img
    title="显示列表"
    v-if="hidedatalist && showresultdialog"
    @click="togglelist"
    class="myimg"
    src="../assets/list.png"
    width="48"
    height="48"
  />

  <transition
    enter-active-class="animate__animated animate__fadeInLeftBig"
    leave-active-class="animate__animated animate__fadeOutLeftBig"
  >
    <div class="resultlistboard" v-if="!hidedatalist">
      <el-row class="row-bg mx-2 mt-2" justify="start">
        <h5>{{ numtitle }}</h5>
      </el-row>
      <button title="隐藏列表" data-tip="关闭" class="btn myclose">
        <i
          style="cursor: hand"
          class="closebutton bi bi-x-lg"
          @click="togglelist"
        ></i>
      </button>

      <div class="tablecontainer">
        <table class="mytable table">
          <tbody>
            <tr
              :class="{ 'table-primary': currentindex == index }"
              v-for="(item, index) in items"
              :key="item.id"
              :id="index"
              @mouseover="myhover(index)"
              @click="zoom2item(index)"
            >
              <td align="left">
                <el-row>
                  <el-col :span="18"
                    ><div>
                      <h2 class="datatitle" :title="item.properties.data_id">
                        {{ index + 1 }}:{{ item.properties.data_id }}
                      </h2>
                    </div></el-col
                  >
                  <el-col :span="1">
                    <img
                      class="mb-2"
                      width="16"
                      height="16"
                      style="cursor: pointer"
                      src="../assets/incart-64.png"
                      v-show="item.properties.cartflag"
                    />
                  </el-col>
                  <el-col :span="3" class="mx-1">
                    <h2
                      :class="[
                        item.properties.datastatus === 'online'
                          ? 'online'
                          : 'offline',
                      ]"
                    >
                      {{
                        $t("resultlistmessage." + item.properties.datastatus)
                      }}
                    </h2>
                  </el-col>
                </el-row>

                <el-row class="row-bg mt-0" justify="start">
                  <!-- 快视图片 -->
                  <el-col :span="8"
                    ><div>
                      <el-image
                        style="width: 56px; height: 56px"
                        :src="'thumbimg?granuleid=' + item.properties.data_id"
                        class="image"
                      /></div
                  ></el-col>
                  <el-col :span="8"
                    ><div class="grid-content mt-3">
                      <tr>
                        <h3>
                          {{ $t("resultlistmessage.satellite") }}:{{
                            item.properties.satellitename
                          }}
                        </h3>
                      </tr>
                      <tr>
                        <h3>
                          {{ $t("resultlistmessage.sensingdate") }}:{{
                            item.properties.startdate
                          }}
                        </h3>
                      </tr>
                    </div></el-col
                  >

                  <!-- 几个图标 -->
                  <el-col :offset="2" class="mt-4" :span="1">
                    <img
                      @click="clickitem(index)"
                      :title="$t('resultlistmessage.viewdata')"
                      v-if="currentindex == index"
                      width="16"
                      height="16"
                      style="cursor: pointer"
                      src="../assets/eye.png"
                  /></el-col>
                  <el-col class="mt-4" :span="1">
                    <button
                      :title="$t('resultlistmessage.zoomtodata')"
                      @click="zoom2item(index)"
                      v-if="currentindex == index"
                      type="button"
                      class="btn aim"
                    />
                  </el-col>
                  <el-col class="mt-4" :span="1">
                    <img
                      @click="ondownloadfile(index)"
                      :title="$t('resultlistmessage.downloaddata')"
                      v-if="currentindex == index"
                      width="16"
                      height="16"
                      style="cursor: pointer"
                      src="../assets/icons8-download-100.png"
                    />
                  </el-col>
                  <el-col class="mt-4" :span="1">
                    <img
                      @click="clickcartitem(index)"
                      :title="carttitle(item.properties.cartflag)"
                      v-if="currentindex == index"
                      width="16"
                      height="16"
                      style="cursor: pointer"
                      :src="cartimgurl(item.properties.cartflag)"
                    />
                  </el-col>
                </el-row>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 分页 -->
      <div class="block mt-2">
        <el-pagination
          v-model:currentPage="currentPage"
          layout="sizes, prev, pager, next"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pagesize"
          :pager-count="5"
          :total="itemcount"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </transition>

  <el-dialog
    destroy-on-close="true"
    top="5vh"
    modal="false"
    open-delay="200"
    close-delay="200"
    close-on-click-modal="false"
    close-on-press-escape="false"
    class="mydia"
    append-to-body="true"
    fullscreen="true"
    v-model="scenemapVisible"
    :show-close="true"
    :title="$t('downloadmessage.title')"
  >
    <div style="width: 100vw; height: 100vh">
      <downloadpage @onclosedownloadpage="closepage"></downloadpage>
    </div>
  </el-dialog>
</template>

<script>
import {
  onMounted,
  onUnmounted,
  toRefs,
  reactive,
  getCurrentInstance,
  computed,
} from "vue";

import { useI18n } from "vue-i18n";
import downloadpage from "./downloadpage.vue";
import { downloadfile, relogin } from "../js/util";
import { getuserprofile } from "../js/userhandler";
import { addtocart, removefromcart,querydata } from "../js/querydata";
import { ElMessageBox, ElMessage } from "element-plus";
export default {
  components: {
    downloadpage,
  },
  setup() {
    const state = reactive({
      items: [],
      currentPage: 1,
      itemcount: 0,
      pagesize: 10,
      currentindex: 0,
      scenemapVisible: false,
      hidedatalist: true,
      showresultdialog: false,
      queryparam:{}
    });
    const { t } = useI18n();

    const numtitle = computed(() => {
      if (state.itemcount == 0) return t("resultlistmessage.nofound");
      else {
        let startindex = state.pagesize * (state.currentPage - 1) + 1;
        let endindex = state.pagesize * state.currentPage;
        if (endindex > state.itemcount) endindex = state.itemcount;
        var display = t("resultlistmessage.display", {
          startindex: startindex,
          endindex: endindex,
          count: state.itemcount,
        });
        return display;
      }
    });

    //购物车标题,根据数据是否在购物车中显示
    const carttitle = (incartflag) => {
      if (incartflag) return t("resultlistmessage.removecart");
      else return t("resultlistmessage.tocart");
    };
    //购物车图片
    const cartimgurl = (incartflag) => {
      if (incartflag) return require("../assets/removecart-64.png");
      else return require("../assets/addcart-64.png");
    };

    const { proxy } = getCurrentInstance(); //获取根元素
    const app = getCurrentInstance();
    onUnmounted(() => {
      proxy.$EventBus.off("myscrolltodomid"); //清理注册的事件
      proxy.$EventBus.off("showresultlist");
    });
    onMounted(() => {
      //注册事件
      
      proxy.$EventBus.on("myscrolltodomid", (domid) => {
        document.getElementById(domid).scrollIntoView(false);
        state.currentindex = domid;
      });
      proxy.$EventBus.on("showresultlist", onshowresultlist);
    });

    //显示结果列表，参数param:查询结果，通过eventbus传递过来
    const onshowresultlist = (param) => {
      if (typeof param === "boolean") {
        if (param != true) {
          state.showresultdialog = true;
          state.hidedatalist = false;
        } else {
          state.showresultdialog = false;
          state.hidedatalist = true;
        }
        return;
      }
      state.queryparam=param.queryobj
      state.currentPage=param.queryobj.pageNo//初始页面位置
      state.pagesize=param.queryobj.pagesize//初始页面大小
      state.itemcount=param.total //数据结果总量

      state.hidedatalist = false;
      state.showresultdialog = true;
      
      state.items = param.features;
      
      showqueryresult(0, ""); //发送地图中显示查询结果的消息
    };

    const handleSizeChange = (val) => {
      //分页大小变化
      let oldpagesize = state.pagesize;
      state.pagesize = val;
      var newpage = Math.ceil(
        ((state.currentPage - 1) * oldpagesize + state.currentindex) /
          state.pagesize
      );
      state.currentPage = newpage;
      state.queryparam.pagesize=val
      state.queryparam.pageNo=newpage

      querydata(state.queryparam).then((res)=>{
        if (res.status === 200)
        {
          if (res.data.status == "1")
          {
            state.items=res.data.features
            showqueryresult(0, "");
          }
        }
      })
    };

    //页面位置变化
    const handleCurrentChange = (val) => {
      state.currentPage = val;
      state.queryparam.pageNo=val
      querydata(state.queryparam).then((res)=>{
        if (res.status === 200)
        {
          if (res.data.status == "1")
          {
            state.items=res.data.features
            showqueryresult(0, "");
          }
        }
      })
    };

    const myhover = (id) => {
      showqueryresult(id, "");
      state.currentindex = id;
    };
    //用户鼠标单击列表项，在Map上实现关联互动
    const clickitem = (id) => {
      getuserprofile().then((res) => {
        if (res.status === 200) {
          if (res.data.status == "1") {
            var item=state.items[id]
            state.scenemapVisible = true;

            var granuleid;
            
            granuleid = item.properties.data_id;

            setTimeout(function() {
              proxy.$EventBus.emit("showscene", granuleid);
              console.log("发送显示景信息");
            }, 300);
          } else {
            let username = app.appContext.config.globalProperties.username;
            relogin(username);
          }
        }
      });
    };


    //用户在结果列表中点下载
    const ondownloadfile = (id) => {
      let item = state.items[id];
      let granuleid = item.properties.data_id;
      if (item.properties.datastatus === "offline") {
        alert(t("resultlistmessage.offlinewaring"));
        return;
      }
      let username = app.appContext.config.globalProperties.username;

      downloadfile(granuleid, username);
           
    };
    //用户点击购物车按钮出发将数据加入或移出购物车事件
    const clickcartitem = (id) => {
      let item=state.items[id]

      try {
        if (!item.properties.cartflag) {
          console.log("加入购物车");
          addtocart(item.properties.data_id).then((res) => {
            console.log("检测调用加入购物车接口");
            if (res.status == 200) {
              console.log("接口有返回200");
              if (res.data.status === "0") {
                ElMessage.error({ message: "Add Product Failed" });
                if (res.data.login === "0") {
                  let username =
                    app.appContext.config.globalProperties.username;
                  relogin(username); //显示登录
                }
              } else {
                item.properties.cartflag = !item.properties.cartflag;
              }
            } else ElMessageBox.alert("Serve error");
          });
        } else {
          console.log("删除购物车");
          removefromcart(item.properties.data_id).then((res) => {
            if (res.status == 200) {
              if (res.data.status === "0") {
                ElMessage.error({ message: "Remove Product Failed" });
                if (res.data.login === "0") {
                  let username =
                    app.appContext.config.globalProperties.username;
                  relogin(username); //显示登录
                }
              } else {
                item.properties.cartflag = !item.properties.cartflag;
              }
            } else ElMessageBox.alert("Serve error");
          });
        }
      } catch (error) {
        console.log("error");
      }
    };

    function showqueryresult(id, method) {
      //发送地图中显示查询结果的消息
    
      var tmp=state.items
      var geom = [];
      for (var i = 0; i < tmp.length; i++) {
        if (id == i) tmp[i].properties.selected = true;
        else tmp[i].properties.selected = false;
        tmp[i].properties.domid = i; //附加的id 用于双向关联
        if (method == "zoom2item") {
          if (id == i) geom.push(tmp[i]);
        } else geom.push(tmp[i]);
      }
      if (method === "zoom2item") proxy.$EventBus.emit("zoom2item", geom);
      else proxy.$EventBus.emit("showqueryframe", geom); //向querymap发送显示结果事件
    }

    const togglelist = () => {
      state.hidedatalist = !state.hidedatalist;
    };
    const zoom2item = (id) => {
      showqueryresult(id, "zoom2item");
      state.currentindex = id;
    };
    const closepage = () => {
      state.scenemapVisible = false;
    };
    return {
      zoom2item,
      togglelist,
      clickitem,
      myhover,
      handleCurrentChange,
      handleSizeChange,
      cartimgurl,
      carttitle,
      clickcartitem,
      closepage,
      ondownloadfile,
      ...toRefs(state),
      numtitle,
    };
  },
};
</script>

<style scoped>
.resultlistboard {
  position: absolute;
  top: 165px;
  left: 25px;
  width: 500px;
  height: 75vh;
  background: #fafafa;
  z-index: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
  overflow: hidden;
  opacity: 1;
  transition: 0.5s;
  /* z-index: 2000; */
}
.mytable {
  overflow-x: hidden !important;
  overflow-y: scroll;
  background: white;
}
.tablecontainer {
  overflow: scroll;
  height: 60vh;
  overflow-x: hidden !important;
  scroll-behavior: smooth;
}
h2 {
  font-size: 12px;
  font-weight: bold;
  font-family: sans-serif;
  text-align: center;
}
h3 {
  font-size: 60%;
  font: bold;
  color: #337ab7;
}
h5 {
  font-size: 80%;
  font: bold;
}
.myclose {
  position: absolute;
  right: 15px;
  top: 5px;
}

.myimg {
  position: absolute;
  left: 25px;
  top: 170px;
  /* z-index: 2000; */
  transition: all 0.8s;
}
.darkbackground {
  background: gray;
}
.datatitle {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all; /* 追加这一行代码 */
}
.aim {
  width: 16px;
  height: 16px;
  background: url("../assets/aim-target-svgrepo-com.svg") no-repeat;
}
.online {
  background: green;
  color: white;
  text-align: center;
}
.offline {
  background: red;
  color: white;
  text-align: center;
}
.animate__animated.animate__fadeInLeftBig {
  --animate-duration: 500ms;
}
.animate__animated.animate__fadeOutLeftBig {
  --animate-duration: 1500ms;
}
.btn:focus,
.btn:active:focus,
.btn.active:focus,
.btn.focus,
.btn:active.focus,
.btn.active.focus {
  outline: none;
  box-shadow: none;
}
/* 老挝语字体 */
.lwfont {
  font-family: "Saysettha OT", sans-serif;
}

/* 英语字体 */
.enfont {
  font-family: "Arial", sans-serif;
}
</style>
